import type {
  StoreTransitionMeetingRequestAnswerOptionsItem,
  TransitionMeetingManageResourceAnswerOptionsItem,
} from "api/generated";
import type { AnswerType } from "api/generated/schemas/answerType";
import type { AnswerOptionIcon } from "api/generated/schemas/answerOptionIcon";
import type { AnswerOption } from "meetings/advisory/types";

export const answerOptionFromDto = (
  dto: TransitionMeetingManageResourceAnswerOptionsItem,
): AnswerOption => ({
  position: dto.position,
  label: dto.label,
  icon: dto.icon as AnswerOptionIcon,
});

export const answerOptionToDto = (
  option: AnswerOption,
): StoreTransitionMeetingRequestAnswerOptionsItem => ({
  position: option.position,
  label: option.label,
  icon: option.icon,
});

export const answerTypeFromDto = (value: string | null): AnswerType | null => {
  if (!value) {
    return null;
  }

  return value as AnswerType;
};
